import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('ja');

@Pipe({
  name: 'month'
})
export class MonthPipe implements PipeTransform {
  constructor() {
  }

  transform(value: any, args?: any): any {
    if (!value) { return ''; }
    return moment(value).format('MM月');
  }

}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/pipes/month.pipe.ts